import {
	Box,
	Card,
	Grid,
	Icon,
	IconButton,
	styled,
	Tooltip,
} from '@mui/material';

const StyledCard = styled(Card)(({ theme }) => ({
	display: 'flex',
	flexWrap: 'wrap',
	alignItems: 'center',
	justifyContent: 'space-between',
	padding: '24px !important',
	background: theme.palette.background.paper,
	[theme.breakpoints.down('sm')]: { padding: '16px !important' },
}));

const ContentBox = styled(Box)(({ theme }) => ({
	display: 'flex',
	flexWrap: 'wrap',
	alignItems: 'center',
	'& small': { color: theme.palette.text.secondary },
	'& .icon': {
		opacity: 0.6,
		fontSize: '44px',
		color: theme.palette.primary.main,
	},
}));

const Heading = styled('h6')(({ theme }) => ({
	margin: 0,
	marginTop: '4px',
	fontSize: '14px',
	fontWeight: '600',
	color: theme.palette.primary.main,
}));

const StarCards = () => {
	const cardList = [
		{
			name: 'Available Balance',
			amount: 3050,
			icon: 'https://cdn-icons-png.flaticon.com/512/25/25473.png',
		},
		{
			name: 'Flight Booked',
			amount: '$80,500',
			icon: 'https://cdn-icons-png.flaticon.com/512/3125/3125713.png',
		},
		{ name: 'Inventory Status', amount: '8.5% Stock Surplus', icon: 'store' },
		{ name: 'Orders to deliver', amount: '305 Orders', icon: 'shopping_cart' },
	];

	return (
		<Grid container spacing={3} sx={{ mb: '24px' }}>
			{cardList.map((item, index) => (
				<Grid item xs={12} md={6} key={index}>
					<StyledCard elevation={2}>
						<ContentBox>
							<img
								src={item.icon}
								// src='https://cdn-icons-png.flaticon.com/512/3125/3125713.png'
								style={{ width: 30, height: 30 }}
							/>
							<Box ml='12px'>
								<span style={{ color: 'grey' }}>{item.name}</span>
								<Heading>{`₹ ${item.amount} `}</Heading>
							</Box>
						</ContentBox>

						<Tooltip title='View Details' placement='top'>
							<img
								src='https://www.freeiconspng.com/uploads/right-arrow-icon-12.png'
								style={{ width: 30, height: 30 }}
							/>
						</Tooltip>
					</StyledCard>
				</Grid>
			))}
		</Grid>
	);
};

export default StarCards;
